"use client";

import { FormLabel } from "@watt/ui/components/ui/form";
import { cn } from "@watt/ui/utils/classname-tailwind-merge";
import type React from "react";

export interface VerificationLabelProps {
  children: React.ReactNode;
  isRequired?: boolean;
  className?: string;
}

export function VerificationLabel({
  children,
  isRequired = false,
  className
}: VerificationLabelProps) {
  return (
    <FormLabel className={cn(className)}>
      {children}
      {isRequired && <span className="text-destructive"> *</span>}
    </FormLabel>
  );
}
